/*global  */
/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('NodesInterceptor', ['$location', '$translate', 'FileSize', 'OfficeOnline', 'RoutePaths',
        function ($location, $translate, FileSize, OfficeOnline, RoutePaths) {
        return {
            response: function (response) {
                var nodes = [];

                if (angular.isArray(response.resource)) {
                    angular.forEach(response.resource, function (entry) {
                        nodes.push(_decorateNode(entry));
                    });
                    return nodes;
                } else {
                    return _decorateNode(response.resource);
                }
            }
        };

        function _decorateNode(node) {
            node.canBeShared = function () {
                return node.permissions.can_be_shared;
            };

            node.canHaveUploadRequest = function () {
                return node.permissions.can_have_upload_request;
            };

            node.canHavePublicFolderLink = function () {
                return node.permissions.can_have_public_folder_link;
            };

            node.canBeSharedViaLink = function () {
                return node.permissions.can_be_shared_via_link;
            };

            node.canShowNotifications = function (account) {
                return node.is_directory && node.is_shared && !node.is_deleted;
            };

            node.isCurrentUserOwner = function (account) {
                return account.email == node['owner_email'];
            };

            node.canBeDeleted = function () {
                return node.permissions.can_be_deleted;
            };

            node.canBeDownloaded = function () {
                return node.permissions.can_be_downloaded;
            };

            node.canBeEdited = function () {
                return OfficeOnline.canEdit(node);
            };

            node.canBeRestored = function () {
                return node.permissions.can_be_restored;
            };

            node.canBeRenamed = function () {
                return node.permissions.can_be_renamed;
            };

            node.canBeMoved = function () {
                return node.permissions.can_be_moved && !node.read_only;
            };

            node.canBeCopied = function () {
                return node.permissions.can_be_copied;
            };

            node.hasMembers = function () {
                return !node.is_deleted && node.is_shared && node.permissions.can_view_members && node.is_directory;
            };

            node.canBeUnsubscribedFrom = function () {
                return node.permissions.can_be_unsubscribed && !node.is_deleted;
            };

            node.canCreateFoldersInto = function () {

                return node.permissions.can_create_folders_into;
            };

            node.canCreateOfficeOnlineFilesInto = function () {
                return OfficeOnline.canCreateInto(node);
            };

            node.canUploadInto = function () {
                return node.permissions.can_create_files_into;
            };

            node.canCreateFilesInto = function () {
                return node.permissions.can_create_files_into;
            };

            node.hasRevisions = function () {
                return node.has_revisions;
            };

            node.hasDeleted = function () {
                return node.has_deleted;
            };

            node.isRoot = function () {
                return node.uuid == '0';
            };

            node.canBeSync = function () {
                return node.permissions.can_be_synced_2_way;
            };

            node.isDeleted = function () {
                return node.is_deleted;
            };

            node.canFilterByOwner = function () {
                return node['type'] === 'sync-and-share';
            };

            node.getFullPath = function () {
                var parents = angular.isArray(node.parents) ? node.parents : [];

                return parents.reduce(function (result, parent, index) {
                    return result + parent.name + (index < parents.length - 1 ? ' / ' : '');
                }, '');
            };

            node.canPurgeAllRevisions = function () {
                return node.permissions.can_selectively_purge_revisions && node.isDeleted();
            };

            node.canPurgeSingleRevision = function () {
                return node.permissions.can_selectively_purge_revisions && !node.isDeleted();
            };

            node.canBeNotarized = function () {
                return node.permissions.can_be_notarized;
            };

            node.canBeSigned = function () {
                return node.permissions.can_be_signed;
            };

            node.hasNotarizationCertificate = function () {
                return node['latest_notarized_revision']
                    && node['latest_notarized_revision']['revision'] === node['revision']
                    && node['latest_notarized_revision']['notarization']['status'] === 'successful';
            };

            node.getUrl = function (withoutHash) {
                var hashChar = withoutHash === true ? '' : '#';

                return hashChar + RoutePaths.NODES + '/' + this.uuid;
            };

            node.getAbsoluteUrl = function () {
                return $location.absUrl().replace('#' + $location.path(), this.getUrl());
            };

            Object.defineProperties(node, {
                hasEsignature: {
                    get: function () {
                        return this.has_esignature;
                    }
                },
                esignatureUrl: {
                    get: function () {
                        return '#' + RoutePaths.SIGNED_FILES + '?highlight_uuid=' + this.uuid;
                    }
                },
                expirationDate: {
                    get: function () {
                        return this.folder_share && this.folder_share.expiration_date;
                    }
                },
                allowGuestDownloads: {
                    get: function () {
                        if (!this.folder_share) {
                            return true; // guest downloads are allowed by default
                        }

                        return this.folder_share.allow_guest_downloads;
                    }
                },
                displayPath: {
                    value: node.path ? `${$translate.instant('Sync & Share')} / ${node.path.split(/[\:\/]/).slice(0, -1).join(' / ')}` : ''
                }
            });

            return node;
        }
    }]);
